import {createContext, type ReactNode, useContext, useEffect, useMemo, useState} from "react";

export type Language = "en" | "zh";

const zh: Record<string, string> = {
 "worker_binding_missing":"该 Worker 未登记在 Manager 当前平台绑定中",
 "Stop accepting tasks":"停止接收",
 "Resume accepting tasks":"恢复接收",
 "accepting-tasks":"接收新任务",
 "intake-paused":"已停止接收",
 "intake-unavailable":"暂不可接收",
 "New task intake stopped. Already submitted tasks continue.":"已停止接收新任务。此前已提交的任务仍会继续执行。",
 "New task intake resumed.":"已恢复接收新任务。",
 "Existing tasks can execute":"已有任务可执行",
 "Execution is unavailable":"当前无法执行",
 "Worker capacity":"Worker 并发容量",
 "worker_ready":"连接和契约正常",
 "worker_intake_paused":"已停止接收；此前提交的任务继续执行",
 "manager_disabled":"Manager 已禁用",
 "manager_offline":"Manager 心跳过期或尚未连接",
 "deployment_pending":"实例部署或校验尚未完成",
 "spec_disabled":"Spec 已禁用",
 "worker_offline":"Worker 尚未连接 Manager",
 "spec_not_accepted":"Worker 契约尚未接受或缺少可用版本",
 "runtime_not_ready":"Manager 正在同步或校验当前平台绑定",
 "runtime_status_unknown":"等待运行状态上报",
 "Worker operations guide":"Manager / Worker 部署与运行说明",
 "Manage Worker connections and new task intake. Already submitted tasks continue when intake is stopped.":"管理 Worker 连接和新任务接收状态。停止接收后，此前已提交的任务仍会继续执行。",

 "Copy another instance":"再复制一个实例",
 "Copy Worker":"复制 Worker",
 "Target Manager":"目标 Manager",
 "New Worker name":"新 Worker 名称",
 "Start copy":"开始复制",
 "Copy progress":"复制进度",
 "Cancel copy":"取消复制",
 "Retry copy":"重试复制",
 "Deployment phase":"部署阶段",
 "Cancellation requested":"已请求取消",
 "preflight":"环境预检查",
 "export":"源节点导出",
 "install":"目标安装",
 "verify":"启动与 Spec 验证",
 "rollback":"清理目标实例",
 "done":"结束",
 "Keep the source Worker and install a new independent identity on another Manager.":"保留源 Worker，在另一个 Manager 安装独立的新实例。",
 "This Worker has no managed deployment recipe. Its existing execution is unchanged.":"此 Worker 尚未登记可用部署清单，现有任务执行不受影响。",
 "A new Worker ID is generated. Spec definitions stay unchanged. Source credentials, virtual environments and task data are excluded. Python dependencies are rebuilt on the target.":"系统生成新的 Worker ID，Spec 原文保持不变。不复制源凭据、虚拟环境和任务数据，Python 依赖在目标重新安装。",
 "This release supports BiliCrawler, MarkItDown and AudioExtractor CPU deployment recipes. GPU/model deployment is not advertised until its own recipe is available.":"本版支持 BiliCrawler、MarkItDown、AudioExtractor 的 CPU 部署清单；GPU 与模型部署须具备对应清单后才开放。",
 "New Worker is online with the original Spec. Compatible Controllers can select both Workers.":"新 Worker 已在线且 Spec 保持一致，兼容 Controller 可以选择两个 Worker。",

 "Edit Platform metadata without changing the published business contract.":"编辑 Platform 调度配置与描述，已发布的业务契约保持不变。",
 "Legacy compatibility (read-only)":"旧版兼容定义（只读，分类以 Platform 设置为准）",

 "Edit Spec":"编辑 Spec",
 "Business contract":"业务契约",
 "Submitted classification":"提交时分类",
 "This is a Platform scheduling setting. Worker Spec definitions remain unchanged.":"这是 Platform 的调度配置，不会修改 Worker 上传的 Spec 定义。",
 "Changes affect newly submitted tasks only. Queued and running tasks keep their saved classification.":"修改只影响此后新建的任务。已排队和正在执行的任务保留提交时的分类，不会改写 Spec 定义。",

 "Configure the display name and node execution capacity.":"配置显示名称和节点执行容量。",
 "This node takes execution settings from another profile.":"此节点由其他平台管理执行配置，本页仅显示。",
 "Parallel concurrency":"节点并行度",
 "Execution mode":"执行分类",
 "Serial":"串行",
 "Parallel":"并行",
 "Configuration source":"配置来源",
 "Serial capacity is fixed at 1. Parallel tasks use an independent lane. Changes apply on heartbeat; running tasks finish normally.":"串行固定1槽，与并行通道独立运行。心跳后生效；降低并行度不会中断正在执行的任务。",
 "The initial Worker Spec must match this category. Published versions keep their own immutable execution mode.":"Worker首次上报的Spec须与所选分类一致。已发布版本的执行分类保持不变。",

  "Delete Worker": "删除 Worker",
  "Remove this Worker registration. Existing Task records and files are retained.": "删除此 Worker 注册，保留已有任务记录和文件。",
  "A Worker with unfinished Tasks cannot be deleted. To use it again after deletion, register a new Worker ID and update the Manager mapping.": "存在未完成任务时无法删除。删除后如需重新使用，请注册新的 Worker ID 并更新 Manager 映射。",
  "This Worker has {{tasks}} unfinished Task(s). Complete or cancel them before deleting.": "此 Worker 还有 {{tasks}} 个未完成任务，请先完成或取消这些任务，再删除。",
  "Worker deleted. Task records and files are retained.": "Worker 已删除，任务记录和文件已保留。",
  "Spec family deleted.": "Spec 家族已删除。",
  "Remove the referencing Workers and Controllers first, then retry.": "请先删除引用它的 Worker 和 Controller，再重试。",
  "Deleting\u2026": "正在删除…",
  "Login devices": "登录设备",
  "View your active browser sessions and remotely sign out devices.": "查看当前账号的浏览器登录会话，并远程退出设备。",
  "Online": "在线",
  "Signed in": "已登录",
  "Current device": "当前设备",
  "Other device": "其他设备",
  "Local account": "本地账号",
  "Device / browser": "设备 / 浏览器",
  "IP address": "IP 地址",
  "Login time": "登录时间",
  "Last active": "最后活跃",
  "Recently offline": "最近离线",
  "Login IP": "登录 IP",
  "Expires": "到期时间",
  "Sign out device": "退出此设备",
  "Sign out this device": "退出当前设备",
  "Sign out other devices": "退出其他所有设备",
  "Confirm sign out": "确认退出",
  "Signing out\u2026": "正在退出…",
  "Selected sessions have been signed out.": "所选设备已退出登录。",
  "One browser profile is one session; tabs share a session. Different browsers on the same computer appear separately.": "同一浏览器配置下的标签页共享一个登录会话；同一电脑使用不同浏览器会分别显示。",
  "Pages send a heartbeat every 30 seconds. Sessions without activity for 2 minutes are shown as recently offline; they remain signed in until revoked or expired.": "页面每 30 秒发送心跳，连续 2 分钟没有活动会显示为最近离线；会话在退出或到期前仍处于登录状态。",
  "The selected sessions lose access immediately. Submitted background tasks continue running.": "所选会话会立即失去访问权限，已提交的后台任务继续执行。",
  "Your current device stays signed in. All other sessions of this account will be signed out.": "当前设备保留登录，此账号的其他所有会话将退出。",
  "Your password changed on another device. Sign in again.": "其他设备修改了密码，请重新登录。",
  "This device was signed out remotely. Sign in again.": "此设备已被远程退出，请重新登录。",
  "Your session expired. Sign in again.": "登录已过期，请重新登录。",
  "Machine": "机器",
  "Waiting for heartbeat": "等待心跳",
  "View": "查看",
  "Machine details": "机器详情",
  "Live host information reported by this Manager heartbeat.": "由此 Manager 心跳上报的实时主机信息。",
  "CPU usage": "CPU 占用",
  "logical CPUs": "个逻辑 CPU",
  "Memory usage": "内存占用",
  "Disk usage": "磁盘占用",
  "Operating system": "操作系统",
  "Manager version": "Manager 版本",
  "System uptime": "系统运行时间",
  "Load average": "平均负载",
  "Disk mount": "磁盘挂载点",
  "Metrics collected": "指标采集时间",
  "Workers on": "机器上的 Workers：",
  "Workers assigned to this machine connect only through its local Manager runtime.": "分配到此机器的 Worker 仅通过本机 Manager Runtime 连接。",
  "Registered workers": "已注册 Worker",
  "New worker": "新增 Worker",
  "Worker name": "Worker 名称",
  "Spec name": "Spec 名称",
  "Expected versions": "预期版本",
  "Create worker": "创建 Worker",
  "Worker created. Use this ID when starting the Worker:": "Worker 已创建。启动 Worker 时请使用此 ID：",
  "No Workers on this machine": "此机器暂无 Worker",
  "Create a Worker assignment, then start the Worker process locally with its Worker ID.": "先创建 Worker 分配，再使用 Worker ID 在本机启动 Worker 进程。",
  "Workspace": "工作台",
  "Execution": "执行管理",
  "Activity": "运行记录",
  "Configuration": "配置",
  "Overview": "概览",
  "Managers": "Managers 注册",
  "Workers": "Workers 管理",
  "Spec Registry": "Specs 注册",
  "Controllers": "Controllers 管理",
  "Tasks": "运行任务",
  "Managers Registration": "Managers 注册",
  "Workers Management": "Workers 管理",
  "Specs Registration": "Specs 注册",
  "Controllers Management": "Controllers 管理",
  "Running Tasks": "运行任务",
  "Artifacts": "产物",
  "Settings": "设置",
  "Storage": "存储",
  "Authentication": "身份认证",
  "API Documentation": "API 文档",
  "Platform": "平台",
  "Connecting to the control plane…": "正在连接控制平面…",
  "Open overview": "打开概览",
  "Primary navigation": "主导航",
  "Navigation": "导航",
  "Close navigation": "关闭导航",
  "Open navigation": "打开导航",
  "Expand sidebar": "展开侧边栏",
  "Collapse sidebar": "收起侧边栏",
  "Use light theme": "使用浅色主题",
  "Use dark theme": "使用深色主题",
  "Administrator": "管理员",
  "Platform online": "平台在线",
  "Open account settings": "打开个人设置",
  "Account settings": "个人设置",
  "Manage your Platform identity and sign-in credentials.": "管理您的 Platform 身份和登录凭据。",
  "Profile": "个人资料",
  "Update the name shown in the sidebar and your local login username.": "修改侧边栏显示名称和本地登录用户名。",
  "Display name": "显示名称",
  "Save profile": "保存个人资料",
  "Profile updated.": "个人资料已更新。",
  "Profile updated. Use the new username the next time you sign in.": "个人资料已更新，下次登录请使用新的用户名。",
  "This username is already in use.": "该用户名已被使用。",
  "Change password": "修改密码",
  "Use at least 8 characters. Your current session will remain active.": "密码至少需要 8 个字符，当前会话将保持登录。",
  "Current password": "当前密码",
  "New password": "新密码",
  "Confirm new password": "确认新密码",
  "Update password": "更新密码",
  "The new passwords do not match.": "两次输入的新密码不一致。",
  "The new password must contain 8 to 128 characters.": "新密码长度必须为 8 到 128 个字符。",
  "The current password is incorrect.": "当前密码不正确。",
  "Password updated. Other sessions have been signed out.": "密码已更新，其他会话已退出。",
  "This account is managed by your OIDC identity provider. Local Platform accounts remain available independently.": "此账户由 OIDC 身份提供方管理，本地 Platform 账户仍可独立使用。",
  "Sign out": "退出登录",
  "Protocol v1": "协议 v1",
  "Sign in to Layla TAB": "登录 Layla TAB",
  "Manage contracts, execution nodes, tasks, and artifacts from one control plane.": "在统一控制平面中管理业务契约、执行节点、任务和产物。",
  "Username": "用户名",
  "Password": "密码",
  "Signing in…": "正在登录…",
  "Sign in": "登录",
  "Continue with OIDC": "使用 OIDC 继续",
  "Refresh": "刷新",
  "A live summary of the Layla execution control plane.": "Layla 执行控制平面的实时概览。",
  "Specs": "Specs",
  "Architecture health": "架构运行状态",
  "Platform readiness and optional extension status.": "平台就绪状态与可选扩展状态。",
  "Platform Core": "Platform Core",
  "Ready without extensions": "无需扩展即可运行",
  "Artifact Storage": "产物存储",
  "S3 adapter ready": "S3 适配器已就绪",
  "Configuration required": "需要配置",
  "Protocol Registry": "协议注册表",
  "Register and control the hosts that coordinate local Workers.": "注册并管理负责协调本地 Worker 的主机。",
  "New manager": "新增 Manager",
  "Register Manager": "注册 Manager",
  "The Manager Key is shown once after creation.": "Manager Key 只会在创建后显示一次。",
  "Manager name": "Manager 名称",
  "Production executor": "生产执行器",
  "Cancel": "取消",
  "Create manager": "创建 Manager",
  "Save this Manager Key now.": "请立即保存此 Manager Key。",
  "Copy": "复制",
  "No Managers yet": "暂无 Manager",
  "The Platform remains operational. Register a Manager when an execution host is ready.": "平台仍可正常运行；执行主机就绪后即可注册 Manager。",
  "Name": "名称",
  "ID": "ID",
  "Status": "状态",
  "Last heartbeat": "最近心跳",
  "Actions": "操作",
  "Disable": "禁用",
  "Enable": "启用",
  "Never": "从未",
  "Inspect Worker connectivity, contract validation, and active Spec versions.": "查看 Worker 连接、契约校验和当前 Spec 版本。",
  "No Workers registered": "暂无 Worker",
  "Workers appear here after they are assigned to a Manager and connect through the local runtime protocol.": "Worker 分配给 Manager 并通过本地运行时协议连接后会显示在这里。",
  "Worker": "Worker",
  "Spec": "Spec",
  "Runtime": "运行状态",
  "Validation": "校验状态",
  "Active version": "当前版本",
  "Set": "设置",
  "Versioned, immutable business contracts shared by Controllers and Workers.": "由 Controller 与 Worker 共享的版本化、不可变业务契约。",
  "New draft": "新建草稿",
  "Create Spec family": "创建 Spec 系列",
  "Create the stable identity before publishing immutable versions.": "发布不可变版本前，先创建稳定标识。",
  "Stable name": "稳定名称",
  "DocumentConversion": "文档转换",
  "Description": "描述",
  "What this capability provides": "说明此能力提供的功能",
  "Create draft": "创建草稿",
  "Registry is empty": "注册表为空",
  "Create the first business contract family when a capability is ready to be described.": "当能力定义就绪时，创建第一个业务契约系列。",
  "No description provided.": "未提供描述。",
  "published version": "个已发布版本",
  "published versions": "个已发布版本",
  "Validate and activate independent UI packages against Registry contracts.": "依据注册表契约校验并启用独立 UI 包。",
  "Controller enablement rechecked the Registry, but no declared version matches a published Spec yet.": "启用 Controller 时已重新校验注册表，但目前仍没有声明版本与已发布的 Spec 匹配。",
  "Add Controller": "新增 Controller",
  "Choose how to add a Controller": "选择新增 Controller 的方式",
  "Controller packages are validated against public Registry contracts before installation.": "Controller 包会在安装前依据公共注册表契约进行校验。",
  "Upload Controller UI": "上传 Controller UI",
  "Install a static ZIP package containing an independently built Controller UI.": "安装包含独立构建 Controller UI 的静态 ZIP 包。",
  "Upload Controller UI package": "上传 Controller UI 包",
  "Upload a static ZIP package with a complete, verifiable Spec declaration.": "上传包含完整且可验证 Spec 声明的静态 ZIP 包。",
  "Select Controller package": "选择 Controller 包",
  "ZIP packages up to 64 MB": "ZIP 包最大 64 MB",
  "Back": "返回",
  "Validate and install": "校验并安装",
  "No Controllers installed": "暂无 Controller",
  "Installed Controller packages will be validated and listed here.": "安装后的 Controller 包会经过校验并显示在这里。",
  "Controller": "Controller",
  "Open": "打开",
  "Activate": "启用",
  "Inactive": "未启用",
  "Trace every execution from creation through its terminal result.": "跟踪每次执行从创建到最终结果的全过程。",
  "No Tasks yet": "暂无任务",
  "Task execution is disabled because the S3 bucket is not configured or cannot be reached.": "由于 S3 bucket 未配置或无法访问，任务执行已禁用。",
  "Tasks created by active Controllers will appear in this timeline.": "启用的 Controller 创建的任务会显示在这里。",
  "Task": "任务",
  "Progress": "进度",
  "Version": "版本",
  "Waiting for progress": "等待进度",
  "Browse registered input and output files without exposing storage credentials.": "浏览已注册的输入输出文件，无需暴露存储凭据。",
  "No Artifacts registered": "暂无产物",
  "Files uploaded by a Controller or produced by a Worker will appear here.": "Controller 上传或 Worker 生成的文件会显示在这里。",
  "File": "文件",
  "Role": "角色",
  "Direction": "方向",
  "Size": "大小",
  "Created": "创建时间",
  "General preferences for the Platform administration console.": "Platform 管理控制台的通用偏好设置。",
  "Language": "语言",
  "Choose the display language for this browser.": "选择当前浏览器的显示语言。",
  "English": "English",
  "Chinese": "中文",
  "Current language": "当前语言",
  "Changes are applied immediately and saved in this browser.": "更改会立即生效，并保存在当前浏览器中。",
  "Platform configuration": "平台配置",
  "Storage and authentication are available as secondary items under Settings.": "存储和身份认证位于“设置”的二级菜单中。",
  "Configure storage": "配置存储",
  "Configure authentication": "配置身份认证",
  "Configure the S3-compatible object store used for Artifact transfer.": "配置用于产物传输的 S3 兼容对象存储。",
  "S3-compatible storage": "S3 兼容存储",
  "Credentials remain inside Platform and are never exposed to Controllers or Workers.": "凭据只保留在 Platform 内，不会暴露给 Controller 或 Worker。",
  "Endpoint": "服务地址",
  "Region": "区域",
  "Bucket": "存储桶",
  "Access key": "Access Key",
  "Secret key": "Secret Key",
  "Object prefix": "对象前缀",
  "Save configuration": "保存配置",
  "Save and apply": "保存并应用",
  "Test connection": "测试连接",
  "Testing…": "测试中…",
  "Saved secret — leave blank to keep it": "Secret 已保存，留空则保持不变",
  "Storage settings saved and applied.": "存储设置已保存并立即生效。",
  "S3 connection and read/write verification passed.": "S3 连接成功，读写验证已通过。",
  "Tasks cannot be created, claimed, or started until the configured S3 bucket is reachable.": "在配置的 S3 bucket 可访问之前，任务无法创建、领取或启动。",
  "Storage settings saved. Restart Platform to activate the adapter.": "存储设置已保存，重启 Platform 后适配器生效。",
  "Initialize S3 storage": "初始化 S3 存储",
  "Create the required object prefixes and verify that Platform can write and read the bucket.": "创建所需的对象前缀，并验证 Platform 能够写入和读取该 bucket。",
  "Initialization is idempotent. Existing Task files are not modified or deleted.": "初始化操作可安全重复执行，不会修改或删除已有任务文件。",
  "The initialization record and Task prefix markers will remain visible in the bucket browser.": "初始化只创建 uploads 与 outputs 目录占位对象；平台状态仍保存在数据库中。",
  "Only uploads and outputs directory markers are written to S3; Platform state remains in its database.": "S3 中只写入 uploads 与 outputs 目录占位对象；Platform 状态始终保存在数据库中。",
  "Initialize storage": "初始化存储",
  "Initialize again": "重新初始化",
  "Initializing…": "正在初始化…",
  "Storage initialized and read/write verification passed.": "存储初始化完成，读写验证已通过。",
  "Initialization status": "初始化状态",
  "Read/write verified": "读写验证通过",
  "Verification required": "需要验证",
  "Runtime behavior": "运行行为",
  "How Platform behaves when storage is unavailable.": "存储不可用时 Platform 的运行方式。",
  "Control plane": "控制平面",
  "Available": "可用",
  "Artifact upload": "产物上传",
  "Requires S3": "需要 S3",
  "Configuration activation": "配置生效",
  "After restart": "重启后",
  "Credential exposure": "凭据范围",
  "Platform only": "仅 Platform",
  "Bucket browser": "Bucket 文件浏览器",
  "Browse every object currently stored in the configured bucket.": "浏览当前配置 bucket 中存储的全部对象。",
  "Loading bucket…": "正在加载 bucket…",
  "Bucket unavailable": "Bucket 不可用",
  "Configure a reachable S3 bucket and restart Platform before running tasks or browsing files.": "请配置可访问的 S3 bucket 并重启 Platform，之后才能运行任务或浏览文件。",
  "Bucket is empty": "Bucket 为空",
  "Files written by Controllers and Workers will appear here.": "Controller 与 Worker 写入的文件会显示在这里。",
  "Download": "下载",
  "File not found in the current S3 bucket.": "当前 S3 Bucket 中找不到此文件。",
  "Platform management remains available even when the optional Artifact store is not configured.": "即使未配置可选产物存储，Platform 管理功能仍然可用。",
  "Connect an OpenID Connect provider while retaining fail-closed validation.": "连接 OpenID Connect 提供方，并保持失败关闭校验。",
  "OIDC provider": "OIDC 提供方",
  "Authorization Code with PKCE, state, nonce, issuer, and audience checks.": "使用带 PKCE 的授权码流程，并校验 state、nonce、issuer 和 audience。",
  "Issuer": "Issuer",
  "Client ID": "Client ID",
  "Client secret": "Client Secret",
  "Redirect URL": "回调地址",
  "Save OIDC settings": "保存 OIDC 设置",
  "OIDC configuration saved.": "OIDC 配置已保存。",
  "OIDC and local Platform accounts are independent. Enabling OIDC never disables local username and password sign-in.": "OIDC 与 Platform 本地账户相互独立；启用 OIDC 不会关闭本地用户名和密码登录。",
  "Security profile": "安全配置",
  "Stable security properties applied by Platform.": "Platform 应用的稳定安全属性。",
  "Flow": "流程",
  "State and nonce": "State 与 nonce",
  "Required": "必需",
  "Issuer validation": "Issuer 校验",
  "Audience validation": "Audience 校验",
  "Machine-readable public contracts for independent Manager and Controller implementations.": "面向独立 Manager 与 Controller 实现的机器可读公共契约。",
  "Profiles": "配置范围",
  "Compatibility": "兼容策略",
  "Additive evolution": "仅增量演进",
  "One versioned source of truth": "唯一的版本化事实来源",
  "Stable transport shapes prevent internal implementation details from leaking across component boundaries.": "稳定的传输结构可防止内部实现细节泄漏到组件边界之外。",
  "Manager and Controller profiles share IDs, Task, Spec, Artifact, error, timestamp, and correlation structures. Business payloads remain opaque to Platform and Manager.": "Manager 与 Controller 配置共享 ID、Task、Spec、Artifact、错误、时间戳和关联结构。业务载荷对 Platform 与 Manager 保持不透明。",
  "Open machine-readable OpenAPI": "打开机器可读 OpenAPI",
  "Functions": "功能",
  "View Workers": "查看 Workers",
  "Manager Key": "Manager Key",
  "Reveal": "显示",
  "Hide": "隐藏",
  "Read-only view of Workers assigned to this Manager. Manage Workers from the Workers page.": "只读查看分配给此 Manager 的 Worker；请在 Worker 管理页面进行管理。",
  "Manage every Worker across all Managers and inspect its runtime, contracts, and execution history.": "管理所有 Manager 上的全部 Worker，并查看其运行时、契约与执行历史。",
  "Register Worker": "注册 Worker",
  "Assign the Worker to a Manager and Spec. The Worker reports and controls its active version when it connects.": "将 Worker 分配给 Manager 与 Spec；Worker 连接时自行上报并控制当前版本。",
  "Manager": "Manager",
  "Select Manager": "选择 Manager",
  "Select Spec": "选择 Spec",
  "Filter by Manager": "按 Manager 筛选",
  "All Managers": "全部 Manager",
  "Not reported": "未上报",
  "Reported by Worker": "由 Worker 上报",
  "Edit": "编辑",
  "Edit Spec description": "编辑 Spec 描述",
  "Only the descriptive metadata is editable. Published Spec versions remain immutable.": "只能编辑描述信息，已发布的 Spec 版本仍保持不可变。",
  "Save description": "保存描述",
  "Delete Spec family": "删除 Spec 家族",
  "This permanently removes every published version in the Spec family.": "此操作会永久删除该 Spec 家族的所有已发布版本。",
  "Historical Tasks and S3 files are retained, but their complete Spec definition can no longer be traced after deletion.": "历史任务和 S3 文件会保留，但删除后将无法再追溯完整的 Spec 定义。",
  "This Spec is still referenced by {{workers}} Worker(s) and {{controllers}} Controller(s).": "该 Spec 仍被 {{workers}} 个 Worker 和 {{controllers}} 个 Controller 引用。",
  "Published from a Worker declaration": "由 Worker 声明发布",
  "Runtime configuration and supported contracts reported by this Worker.": "查看此 Worker 上报的运行时配置与支持的契约。",
  "Worker filter": "Worker 筛选",
  "Filter Tasks by Manager": "按 Manager 筛选运行任务",
  "Filter Tasks by Worker": "按 Worker 筛选运行任务",
  "All Workers": "全部 Workers",
  "Details": "详情",
  "Worker details": "Worker 详情",
  "Runtime configuration, supported contracts, and every Task executed by this Worker.": "查看此 Worker 的运行时配置、支持的契约以及执行过的全部任务。",
  "Worker ID": "Worker ID",
  "Runtime version": "运行时版本",
  "Active Spec version": "当前 Spec 版本",
  "Last seen": "最近在线",
  "Effective state": "实际状态",
  "Worker configuration": "Worker 配置",
  "Configuration known to Platform and reported by the Worker runtime.": "Platform 已知并由 Worker 运行时上报的配置。",
  "Supported Specs": "支持的 Specs",
  "The first accepted declaration is controlled by the Worker as its active version.": "Worker 通过首个已接受声明自行确定当前版本。",
  "No supported Specs reported": "尚未上报支持的 Specs",
  "Start the Worker to publish its contract declarations.": "启动 Worker 后将发布其契约声明。",
  "Digest": "摘要",
  "Task history": "任务历史",
  "All executions assigned to this Worker.": "分配给此 Worker 的所有执行记录。",
  "No Tasks for this Worker": "此 Worker 暂无任务",
  "Task executions will appear here.": "任务执行记录会显示在这里。",
  "Spec details": "Spec 详情",
  "Immutable JSON contracts and their Worker implementations.": "查看不可变 JSON 契约及其 Worker 实现。",
  "Disable Spec": "禁用 Spec",
  "Enable Spec": "启用 Spec",
  "Every Worker using this Spec is currently unavailable for new Tasks.": "使用此 Spec 的所有 Worker 当前均不可接收新任务。",
  "Published definitions": "已发布定义",
  "Every immutable field and JSON rule published for this Spec.": "此 Spec 已发布的全部不可变字段与 JSON 规则。",
  "No published versions": "暂无已发布版本",
  "A Worker publishes the first validated version.": "首个校验通过的版本由 Worker 发布。",
  "Workers using this Spec": "使用此 Spec 的 Workers",
  "Workers across every Manager that declare this contract family.": "所有 Manager 上声明此契约系列的 Worker。",
  "No Workers use this Spec": "暂无 Worker 使用此 Spec",
  "Worker declarations will appear here after connection.": "Worker 连接后的声明会显示在这里。",
  "Selected automatically": "自动选择",
  "Delete": "删除",
  "Delete Manager": "删除 Manager",
  "The Manager Key will stop working immediately. Task history is retained.": "Manager Key 将立即失效，历史任务会保留。",
  "Confirm deletion": "确认删除",
  "Workers registered under this Manager will be disabled and disconnected. This action cannot be undone.": "此 Manager 下注册的 Worker 将被禁用并断开连接，此操作无法撤销。",
  "Delete Controller": "删除 Controller",
  "This removes the installed UI package. Existing Task history is retained.": "这会移除已安装的 UI 包，但保留既有任务历史。",
  "Delete permanently": "永久删除",
  "The Controller will disappear from management and the sidebar. This action cannot restore its UI package.": "该 Controller 将从管理页面与侧栏消失，且无法恢复其 UI 包。",
  "Controller details": "Controller 详情",
  "Inspect the Controller package, public contracts, compatible Workers, and Platform interfaces.": "查看 Controller 包、公共契约、兼容 Worker 与 Platform 接口。",
  "Open in Platform": "在 Platform 中打开",
  "This Controller cannot run because its Spec is disabled.": "此 Controller 的 Spec 已禁用，因此无法运行。",
  "Controller ID": "Controller ID",
  "Controller version": "Controller 版本",
  "Sidebar alias": "侧边栏别名",
  "Alias": "别名",
  "The alias only changes this Controller's label in the Functions section.": "别名只改变该 Controller 在左侧功能区域中的显示名称。",
  "Edit Controller": "编辑 Controller",
  "Edit descriptive metadata without changing the installed package or Spec contract.": "编辑描述性元数据，不改变已安装包或 Spec 契约。",
  "What this Controller provides": "说明此 Controller 提供的功能",
  "Save changes": "保存修改",
  "Save alias": "保存别名",
  "Saving…": "保存中…",
  "Validate and install Controller UI": "校验并安装 Controller UI",
  "Review the selected ZIP package before Platform validates its manifest and Spec declarations.": "确认所选 ZIP 包，然后由 Platform 校验清单与 Spec 声明。",
  "Choose another file": "选择其他文件",
  "Installing…": "安装中…",
  "Controller manifest": "Controller 清单",
  "The validated package metadata used by Platform.": "Platform 使用的已校验包元数据。",
  "Immutable contract versions declared by this Controller.": "此 Controller 声明的不可变契约版本。",
  "No supported Specs declared": "未声明支持的 Specs",
  "A valid Controller package must declare at least one contract version.": "有效的 Controller 包至少需要声明一个契约版本。",
  "Usable Workers": "可用 Workers",
  "Workers with a matching accepted Spec digest across all Managers.": "全部 Manager 上具有相同且已接受 Spec 摘要的 Worker。",
  "No compatible Workers": "暂无兼容 Worker",
  "Connect an enabled Worker that publishes the same Spec version and digest.": "请连接已启用且发布相同 Spec 版本与摘要的 Worker。",
  "Availability": "可用性",
  "Platform interfaces": "Platform 接口",
  "Public Controller SDK operations exposed through the sandbox bridge.": "通过沙箱桥接公开的 Controller SDK 操作。",
  "Controller UI runs inside the Platform workspace through the public SDK bridge.": "Controller UI 通过公共 SDK 桥接在 Platform 工作区内运行。",
  "Controller management": "Controller 管理",
  "Controller is unavailable": "Controller 当前不可用",
  "Its Spec is disabled. Enable the Spec before using this Controller.": "其 Spec 已禁用，请先启用 Spec 再使用此 Controller。",
  "Enable this accepted Controller before opening its function page.": "请先启用已校验通过的 Controller，再打开其功能页面。",
  "Open Controller management": "打开 Controller 管理",
  "Manager filter": "Manager 筛选",
  "Task details": "运行任务详情",
  "Review the submitted request, optional S3 inputs, and Worker output without copying files into Platform.": "查看提交请求、可选的 S3 输入和 Worker 输出；文件不会复制到 Platform。",
  "Submitted Task JSON": "提交的任务 JSON",
  "The exact execution envelope and opaque business payload accepted by Platform.": "Platform 接收的完整执行信封与不透明业务载荷。",
  "User input": "用户传入的内容",
  "Review the submitted request, optional S3 inputs, and Worker output. Platform streams user downloads without storing file copies.": "查看提交请求、可选的 S3 输入和 Worker 输出；Platform 以流式方式中转用户下载，不保存文件副本。",
  "Input files remain in S3. Platform securely streams available files to your browser.": "输入文件始终保留在 S3；可用文件由 Platform 安全地流式传输到浏览器。",
  "Worker output": "Worker 产出",
  "Structured Worker result and output files produced for this execution.": "本次执行产生的结构化 Worker 结果和输出文件。",
  "No structured result has been reported yet.": "Worker 尚未上报结构化结果。",
  "Download from S3": "从 S3 下载",
  "Download unavailable": "暂不可下载",
  "Open Storage or Authentication from this Settings page.": "Storage 和 Authentication 仅从此设置页面进入，不在侧边栏显示二级菜单。",
  "Platform architecture and execution workflow": "平台架构与执行流程",
  "The organized product rules used to keep Platform, Manager, Worker, and Controller independent.": "保持 Platform、Manager、Worker 与 Controller 相互独立的产品规则梳理。",
  "Review the product logic, deployment boundaries, and validation rules behind this Platform.": "查看平台背后的产品逻辑、部署边界与验证规则。",
  "View workflow": "查看流程",
  "A concise record of the requirements that govern registration, compatibility, Controller embedding, S3 Artifact transfer, and native execution runtimes.": "集中记录注册、兼容性、Controller 嵌入、S3 产物传输以及本机执行 Runtime 的要求。",
  "Open requirements": "打开需求梳理",
  "Platform owns public contracts": "Platform 负责公共契约",
  "Platform Core stores identities, immutable Specs, task state, and S3 references. Business payloads remain opaque and no extension-specific logic belongs in Core.": "Platform Core 保存身份、不可变 Specs、任务状态与 S3 引用。业务载荷保持不透明，Core 中不得加入扩展专用逻辑。",
  "Manager represents one machine": "Manager 代表一台机器",
  "Exactly one natively deployed Manager coordinates the Workers stored under /opt/Executor/Workers. Manager and Worker remain logically independent over the public protocol.": "每台机器仅本机部署一个 Manager，并协调 /opt/Executor/Workers 下的 Worker；二者仍通过公共协议保持逻辑独立。",
  "Workers declare compatibility": "Worker 声明兼容性",
  "Each Worker owns its runtime version and supported Spec declarations. Platform validates immutable version digests before the Worker becomes available.": "每个 Worker 自主管理运行时版本和支持的 Spec 声明；Platform 校验不可变版本摘要后，Worker 才可用。",
  "Controllers stay independent": "Controller 保持独立",
  "Controller UI packages are uploaded, validated, enabled, and embedded in Platform through the sandboxed public Host SDK. Enabled Controllers appear under Functions.": "Controller UI 包经上传、校验和启用后，通过沙箱公共 Host SDK 嵌入 Platform；已启用 Controller 显示在“功能”下。",
  "Tasks require reachable S3": "运行任务要求 S3 可达",
  "EManager transfers task files with short-lived S3 authorization inside the trusted network. Public browser downloads are streamed through Platform; core identities and history remain in Platform database.": "EManager 在可信内网中使用短期 S3 授权传输任务文件；公网浏览器下载由 Platform 流式中转，核心身份和历史记录始终保存在 Platform 数据库。",
  "Worker Agent development guide": "Worker Agent 开发指南",
  "Create a new EWorker adapter that connects to EManager and publishes an immutable Spec.": "创建连接 EManager 并发布不可变 Spec 的新 EWorker 适配器。",
  "Controller Agent development guide": "Controller Agent 开发指南",
  "Create an independently packaged Controller UI using the sandboxed Host SDK.": "使用沙箱 Host SDK 创建可独立打包的 Controller UI。",
  "Open guide": "打开指南",
  "Develop a Worker": "开发 Worker",
  "Develop a Controller UI": "开发 Controller UI",
  "Agent-ready rules for implementing a new business Worker against an immutable Spec.": "面向 Agent 的完整规则：基于不可变 Spec 实现新的业务 Worker。",
  "Agent-ready rules for packaging a sandboxed feature UI against the public Host SDK.": "面向 Agent 的完整规则：基于公共 Host SDK 打包沙箱功能 UI。",
  "Covers trust boundaries, Runtime Protocol, workspace files, lifecycle reporting, Spec publication, and acceptance tests.": "涵盖信任边界、Runtime Protocol、工作区文件、生命周期上报、Spec 发布和验收测试。",
  "Covers manifests, shared Specs, Host SDK calls, embedded rendering, deterministic packaging, and validation gates.": "涵盖清单、共享 Specs、Host SDK 调用、嵌入渲染、确定性打包和校验门槛。",
  "Define the immutable Spec": "定义不可变 Spec",
  "Describe payload fields, input Artifact roles, result fields, and output Artifact roles before writing runtime code. Controller and Worker definitions must match exactly.": "编写运行时代码前先定义载荷字段、输入产物角色、结果字段和输出产物角色；Controller 与 Worker 的定义必须完全一致。",
  "Use the public Worker SDK": "使用公共 Worker SDK",
  "Connect only to the local EManager endpoint with Worker ID and Manager address. Worker code never receives Platform, Manager Key, S3 credentials, or database access.": "仅使用 Worker ID 和 Manager 地址连接本机 EManager；Worker 代码不得获得 Platform、Manager Key、S3 凭据或数据库访问权。",
  "Own runtime compatibility": "Worker 自主管理运行时兼容性",
  "The Worker reports its runtime version and every supported Spec version during hello. Platform validates the immutable digest and controls effective availability.": "Worker 在 hello 时上报运行时版本和所有支持的 Spec 版本；Platform 校验不可变摘要并控制实际可用性。",
  "Respect the workspace boundary": "遵守工作区边界",
  "Read only declared input paths and write outputs below the supplied output directory. Report relative output paths; EManager performs S3 transfers.": "只读取声明的输入路径，并将输出写入指定 output 目录；仅上报相对路径，由 EManager 完成 S3 传输。",
  "Report the full lifecycle": "上报完整生命周期",
  "Use SDK messages for started, progress, succeeded, and failed. Business payloads and results remain opaque to EManager and Platform.": "通过 SDK 上报 started、progress、succeeded 和 failed；业务载荷与结果对 EManager 和 Platform 保持不透明。",
  "Pass acceptance gates": "通过验收门槛",
  "Test malformed payloads, path traversal, reconnect, quarantine, graceful shutdown, dependency failure, and at least one real task before registration.": "注册前测试错误载荷、路径穿越、重连、隔离、优雅退出、依赖失败，并完成至少一个真实任务。",
  "Select the same Spec": "选择同一份 Spec",
  "Use an existing immutable definition or develop it with the Worker. Never create a Controller-only interpretation of the contract.": "使用既有不可变定义或与 Worker 同步开发；不得创建仅供 Controller 使用的契约解释。",
  "Create the manifest": "创建 Controller 清单",
  "Declare stable identity, Controller version, entry asset, Host SDK protocol version, description, and supported Specs in controller.json.": "在 controller.json 中声明稳定身份、Controller 版本、入口资源、Host SDK 协议版本、描述和支持的 Specs。",
  "Use only Host SDK operations": "仅使用 Host SDK 操作",
  "Obtain context, published Specs, compatible Workers, uploads, tasks, Artifacts, and downloads through the sandbox bridge. Never call EManager, Worker, S3, or internal APIs directly.": "通过沙箱桥接获取上下文、已发布 Specs、兼容 Workers、上传、任务、产物和下载；禁止直接调用 EManager、Worker、S3 或内部 API。",
  "Build an embedded UI": "构建嵌入式 UI",
  "The static UI must render inside Platform's existing page and remain functional under iframe sandbox and Content Security Policy restrictions.": "静态 UI 必须在 Platform 当前页面内渲染，并在 iframe sandbox 与内容安全策略限制下正常工作。",
  "Package deterministically": "确定性打包",
  "Ship controller.json and static assets in one reproducible archive. Reject traversal paths, server executables, credentials, and undeclared external access.": "将 controller.json 与静态资源打成可复现归档；拒绝路径穿越、服务端可执行文件、凭据和未声明外部访问。",
  "Validate before enabling": "启用前完成校验",
  "Upload, inspect Spec validation, enable, verify its Functions entry, and run an end-to-end task without adding Controller-specific Core logic.": "上传并检查 Spec 校验结果，启用后验证功能入口并完成端到端任务，且不得增加 Controller 专用 Core 逻辑。",
  "MarkItDown validates the architecture": "MarkItDown 验证公共架构",
  "MarkItDown is the first proof that the public Spec, SDK, Manager, and Worker architecture is real. MarkItDown-specific branches in Platform Core or Manager Core are treated as protocol design defects.": "MarkItDown 是公共 Spec、SDK、Manager 与 Worker 架构真正成立的第一个验证案例；Platform Core 或 Manager Core 中出现 MarkItDown 专用分支，应视为协议设计缺陷。",
  "Unable to load this page": "无法加载此页面",
  "Retry": "重试",
  "Loading…": "正在加载…",
  "Close": "关闭",
  "The request could not be completed.": "请求无法完成。",
  "Unexpected rendering error.": "页面渲染时发生意外错误。",
  "enabled": "已启用",
  "disabled": "已禁用",
  "accepted": "已接受",
  "online": "在线",
  "ready": "就绪",
  "published": "已发布",
  "succeeded": "成功",
  "failed": "失败",
  "partial-failure": "部分失败",
  "conflict": "冲突",
  "invalid": "无效",
  "interrupted": "已中断",
  "offline": "离线",
  "pending": "等待中",
  "pending-upload": "等待上传",
  "claimed": "已领取",
  "running": "运行中",
  "draft": "草稿",
  "unknown": "未知",
  "Preview": "预览",
  "Cancel running task?": "取消正在运行的任务？",
  "The task will be discarded. EManager will ask the Worker to stop on its next heartbeat.": "任务将被抛弃，EManager 会在下一次心跳时要求 Worker 停止执行。",
  "Keep running": "继续运行",
  "Cancel task": "取消任务",
  "Cancelling…": "正在取消…",
  "Completed work cannot be restored by this action.": "此操作无法恢复已完成的工作。",
  "Supported S3 files are streamed through Platform without exposing the private object-store address.": "支持的 S3 文件由 Platform 转发，不会暴露内网对象存储地址。",
  "No previewable files": "没有可预览的文件",
  "Markdown, common image formats, and audio are currently supported. The file may also be missing from S3.": "当前支持 Markdown、常见图片和音频；文件也可能已从 S3 中消失。",
  "Loading preview…": "正在加载预览…",
  "Artifact preview": "产物预览",
  "Your browser cannot play this audio format.": "当前浏览器无法播放此音频格式。",
  "Preview not supported": "暂不支持预览",
  "Download the file to open it with a local application.": "请下载后使用本地应用打开。",
  "Copyable Agent prompt": "可复制的 Agent 开发提示词",
  "Paste this complete prompt into an Agent task, then append the feature-specific Spec and requirements.": "将完整提示词复制到 Agent 任务中，再附加具体功能的 Spec 和需求。",
  "Paste this complete prompt into an Agent task, then append the feature-specific Spec and UI requirements.": "将完整提示词复制到 Agent 任务中，再附加具体功能的 Spec 和 UI 需求。",
  "Worker Agent prompt": "Worker Agent 提示词",
  "Controller Agent prompt": "Controller Agent 提示词",
  "Copy Worker prompt": "复制 Worker 提示词",
  "Copy Controller prompt": "复制 Controller 提示词",
  "Copied": "已复制",
  "Protocol v1 profiles": "协议 v1 说明",
  "Platform Protocol v1 profiles": "Platform 协议 v1 说明",
  "The three public boundaries implemented by Platform, EManager, EWorker, and Controller UI.": "Platform、EManager、EWorker 与 Controller UI 实现的三类公共边界。",
  "Platform ↔ EManager protocol": "Platform ↔ EManager 协议",
  "HTTPS with a Platform-issued Manager Key. Covers authenticated heartbeat and host status, expected Worker synchronization, Spec reports, task claim/lifecycle, cancellation delivery, and Artifact transfer authorization.": "使用 Platform 发放的 Manager Key 进行 HTTPS 认证，涵盖心跳与主机状态、Worker 同步、Spec 上报、任务领取与生命周期、取消下发和产物传输授权。",
  "EManager ↔ EWorker Runtime protocol": "EManager ↔ EWorker Runtime 协议",
  "Loopback WebSocket trust boundary. Covers Worker hello and immutable Spec declarations, execution workspace, started/progress/terminal events, cooperative task cancellation, and reconnect/quarantine behavior.": "基于回环 WebSocket 的信任边界，涵盖 Worker 握手与不可变 Spec 声明、执行工作区、开始/进度/终态事件、协作取消和重连/隔离。",
  "Platform ↔ Controller Host SDK": "Platform ↔ Controller Host SDK",
  "Sandboxed iframe and MessageChannel bridge. Provides Controller context, published Spec, compatible Workers, Artifact upload/download, task creation/status/cancel, while preventing direct access to S3 and internal APIs.": "通过沙箱 iframe 与 MessageChannel 桥接，提供 Controller 上下文、已发布 Spec、兼容 Worker、产物上传下载及任务创建/状态/取消，并禁止直接访问 S3 和内部接口。",
  "Inspect the Manager, Worker runtime, and Controller Host SDK boundaries behind the top-right protocol button.": "查看右上角协议按钮对应的 Manager、Worker Runtime 和 Controller Host SDK 边界。",
  "View protocols": "查看协议",
  "Open protocol profiles": "打开协议说明",
  "Each profile is independently versioned at the shared public architecture boundary; business-specific behavior remains outside Platform and EManager Core.": "各协议在公共架构边界独立版本化，业务专用行为不得进入 Platform 与 EManager Core。",
  "Edit Manager": "编辑 Manager",
  "Change the Platform display name without changing the Manager ID, Key, or machine hostname.": "仅修改 Platform 中的显示名称，不会改变 Manager ID、Key 或机器主机名。",
  "Manager display name": "Manager 显示名称",
  "This name is presentation-only. Manager authentication and connectivity are unchanged.": "此名称仅用于界面展示，Manager 认证和连接方式保持不变。",
  "Download ZIP": "下载 ZIP",
  "My account": "我的",
  "Settings sections": "设置二级菜单",
  "Architecture references": "架构参考",
  "Protocol boundaries and product rules maintained by Platform.": "由 Platform 维护的协议边界与产品规则。",
  "Extension development": "扩展开发",
  "Generate a constrained Agent task or inspect the fixed Worker and Controller guides.": "生成受约束的 Agent 开发任务，或查看固定的 Worker 与 Controller 指南。",
  "Machine-readable contract": "机器可读协议",
  "Use this source of truth for public transport structures.": "公共传输结构以此版本化定义为唯一事实来源。",
  "New function Agent task generator": "新功能 Agent 任务生成器",
  "Fill the variable business fields; Platform generates the fixed Worker and Controller development workflow.": "填写可变的业务字段，由 Platform 生成固定的 Worker 与 Controller 开发流程。",
  "Function name": "功能名称",
  "Controller name": "Controller 名称",
  "Function description": "功能描述",
  "Spec version": "Spec 版本",
  "Worker path": "Worker 路径",
  "Runtime and dependencies": "运行时与依赖",
  "Immutable Spec JSON": "不可变 Spec JSON",
  "Worker business requirements": "Worker 业务需求",
  "Controller UI requirements": "Controller UI 需求",
  "Acceptance additions": "补充验收要求",
  "Spec definition must be valid JSON.": "Spec 定义必须是有效的 JSON。",
  "Generated Agent task": "已生成的 Agent 任务",
  "The draft is saved in this browser. Copy or download it after completing the required fields.": "草稿会保存在当前浏览器中，填写必填项后可复制或下载。",
  "Copy generated task": "复制生成任务",
  "Download Markdown": "下载 Markdown",
  "No telemetry reported": "暂无遥测数据",
  "Telemetry appears after the updated EManager connects and sends its first sample.": "新版 EManager 连接并上报第一条采样后，这里会显示遥测数据。",
  "Task resource usage": "任务资源占用",
  "Live machine telemetry": "机器实时遥测",
  "recent samples": "条最近采样",
  "Active task": "当前任务",
  "The Manager execution queue is idle.": "Manager 执行队列当前空闲。",
  "Task CPU": "任务 CPU",
  "processes": "个进程",
  "Task memory": "任务内存",
  "Read": "读取",
  "Write": "写入",
  "Task GPU memory": "任务显存",
  "Peak": "峰值",
  "PID association pending": "暂未关联 PID",
  "GPU devices": "GPU 设备",
  "NVIDIA utilization, memory, temperature, and power reported by EManager.": "EManager 上报的 NVIDIA 利用率、显存、温度和功耗。",
  "GPU": "GPU",
  "Utilization": "利用率",
  "GPU memory": "显存",
  "Temperature": "温度",
  "Power": "功耗",
  "Driver": "驱动",
  "Task process tree": "任务进程树",
  "Top processes": "主要进程",
  "Processes are ordered by resident memory; task processes are retained even outside the top list.": "进程按常驻内存排序；任务关联进程即使不在前列也会保留。",
  "Process": "进程",
  "Memory": "内存",
  "Command": "命令行",
  "Listening ports": "监听端口",
  "Current TCP and UDP listeners reported by the host.": "主机当前上报的 TCP 与 UDP 监听端口。",
  "Protocol": "协议",
  "Address": "地址",
  "cancelled": "已取消",
};

type I18nContextValue = {
  language: Language;
  setLanguage: (language: Language) => void;
  t: (key: string, values?: Record<string, string | number>) => string;
};

const I18nContext = createContext<I18nContextValue | null>(null);

function initialLanguage(): Language {
  try {
    const saved = localStorage.getItem("layla-language");
    if (saved === "en" || saved === "zh") return saved;
  } catch {
    // Browser storage can be unavailable in privacy-restricted environments.
  }
  return navigator.language.toLowerCase().startsWith("zh") ? "zh" : "en";
}

export function I18nProvider({children}: {children: ReactNode}) {
  const [language, setLanguage] = useState<Language>(initialLanguage);

  useEffect(() => {
    document.documentElement.lang = language === "zh" ? "zh-CN" : "en";
    try {
      localStorage.setItem("layla-language", language);
    } catch {
      // Language switching still works for the current session.
    }
  }, [language]);

  const value = useMemo<I18nContextValue>(() => ({
    language,
    setLanguage,
    t: (key, values) => {
      let translated = language === "zh" ? zh[key] ?? key : key;
      for (const [name, value] of Object.entries(values ?? {})) {
        translated = translated.replaceAll(`{${name}}`, String(value));
      }
      return translated;
    },
  }), [language]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const value = useContext(I18nContext);
  if (!value) throw new Error("useI18n must be used inside I18nProvider");
  return value;
}
